import { Component, OnInit } from '@angular/core';
import { NationalHolidayService } from '../../services/national-holiday.service';
import { NationalHoliday } from '../../beans/national-holiday';

@Component({
	selector: 'app-national-holiday-admin',
	templateUrl: './national-holiday-admin.component.html',
	styleUrls: ['./national-holiday-admin.component.scss']
})
export class NationalHolidayAdminComponent implements OnInit {

	holidays: NationalHoliday[] = [];
	monthNames = [
		'Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни',
		'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'
	];

	constructor(private holidayService: NationalHolidayService) { }

	ngOnInit() {
		this.load();
	}

	load() {
		this.holidayService.getAll().subscribe(r => {
			r.forEach(h => h.day = this.toPaddedDay(h.day));
			this.holidays = r;
		});
	}

	padDay(h: NationalHoliday) {
		h.day = this.toPaddedDay(h.day);
	}

	private toPaddedDay(day: any): any {
		const n = Number(day);
		if (isNaN(n) || n < 1) return day;
		return n < 10 ? '0' + n : '' + n;
	}

	addNew() {
		this.holidays.unshift({ day: 1, month: 1, name: '' });
	}

	save(h: NationalHoliday) {
		if (!h.name || !h.day || !h.month) {
			alert('Моля, попълнете всички полета.');
			return;
		}
		this.holidayService.add(h).subscribe(saved => {
			Object.assign(h, saved);
		});
	}

	delete(h: NationalHoliday) {
		if (!h.id) {
			this.holidays = this.holidays.filter(x => x !== h);
			return;
		}
		if (!confirm('Сигурни ли сте, че искате да изтриете "' + h.name + '"?')) {
			return;
		}
		this.holidayService.delete(h.id).subscribe(() => {
			this.holidays = this.holidays.filter(x => x.id !== h.id);
		});
	}

	refresh() {
		this.load();
	}
}
